import UPDATE_BUYING_SESSION_GROUP_STATUS_WHOLESALE from './updateBuyingSessionGroupStatus.graphql'
export default UPDATE_BUYING_SESSION_GROUP_STATUS_WHOLESALE
